import { render, staticRenderFns } from "./card-type.vue?vue&type=template&id=966d3622&scoped=true"
import script from "./card-type.vue?vue&type=script&lang=js"
export * from "./card-type.vue?vue&type=script&lang=js"
import style0 from "./card-type.vue?vue&type=style&index=0&id=966d3622&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "966d3622",
  null
  
)

export default component.exports